module.exports = __webpack_public_path__ + "static/media/platform_dots_figure.6e2340eb.png";